// Shimmer version of FullWidthLayout's chrome (logo left, avatar right).
export default function FullWidthShellSkeleton({ children }) {
    return (
        <div style={{ minHeight: '100vh', background: 'rgb(245, 248, 253)' }}>
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '15px 24px', background: '#FFFFFF', borderBottom: '1px solid #E2E8F0',
            }}>
                <div className="shine rounded-2" style={{ width: 130, height: 32 }} />
                <div className="shine rounded-circle" style={{ width: 32, height: 32 }} />
            </div>
            <div style={{ padding: '24px', display: 'flex', justifyContent: 'center' }}>
                <div style={{ maxWidth: 720, width: '100%' }}>
                    {children}
                </div>
            </div>
        </div>
    );
}
